<template>
  <div
    class="bottompopup-fullscreen"
    :class="{ 'darken-animation': showBackground }"
    @click="close()"
  >
    <div
      class="popup-container"
      :class="{ 'popup-container-appear': showBottomPopup }"
      @click.stop
    >
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 0.5rem;
        "
        @click="close"
      >
        <svg width="2rem" height="2rem" viewBox="0 0 24 24">
          <path :d="mdiChevronDown" fill="#cdf4dd" />
        </svg>
      </div>
      <span style="font-size: 1.5rem; font-weight: 300">{{ moveName }}</span>
      <div class="unlock-container">
        <div id="height-filler"></div>
        <div id="hint-text" class="hint-text" style="position: absolute">
          {{ hint }}
        </div>
        <div
          id="hint-button"
          class="hint-button-container"
          @click.stop="showHintClick"
          v-ripple
        >
          <svg width="3rem" height="3rem" viewBox="0 0 24 24">
            <path :d="mdiHelpCircle" fill="#FF3633" />
          </svg>
          <div style="margin-top: 0.5rem">Watch advert to see hint</div>
        </div>
        <div class="hint-button-container" @click="discoverForCredits" v-ripple>
          <svg width="3rem" height="3rem" viewBox="0 0 24 24">
            <path :d="mdiCheckCircle" fill="#468B18" />
          </svg>
          <div style="margin-top: 0.5rem">
            Reveal for {{ creditCost }}
            {{ creditCost > 1 ? 'credits' : 'credit' }}
          </div>
        </div>
      </div>
    </div>
    <div
      class="top-popdown-container"
      :class="{ 'popdown-container-appear': showTopPopup }"
      @click.stop
    >
      <span class="credit-header">Credit balance</span>
      <div class="credit-count" id="credit-balance">
        {{ Math.round(creditBalanceDisplayed) }}
      </div>
      <HeightSwitcher :unlocked="showCreditBuy" :skipFirstFade="showCreditBuy">
        <template v-slot:first><div style="height: 1rem"></div></template>
        <template v-slot:second>
          <BuyCredits @close="close" @hide="hideBuyCredits" />
        </template>
      </HeightSwitcher>
    </div>
    <transition name="dialog-appear">
      <!--<DialogConfirmSimple
        message="Watch the following advert to see the hint"
        button_one="Ok"
        button_two="No thanks"
        v-if="showAdvertConfirmation"
        @button_one_click="yesShowAdvert"
        @button_two_click="dontShowAdvert"
      />-->
      <DialogConfirm v-if="showConfirmDialog" />
    </transition>
    <AdvertPlaceholder v-if="showAdvert" @advert_finished="advertFinished" />
    <!--<transition name="dialog-appear">
      <Hint v-if="showHint" @close_hint="closeHint" />
    </transition>-->
  </div>
</template>

<script>
import DialogConfirm from '@/components/DialogConfirm.vue'
import AdvertPlaceholder from '@/components/AdvertPlaceholder.vue'
import HeightSwitcher from '@/components/HeightSwitcher.vue'
import BuyCredits from '@/components/BuyCredits.vue'
import { mdiChevronDown, mdiHelpCircle, mdiCheckCircle } from '@mdi/js'

import gsap from 'gsap'

//mdiChevronDown
export default {
  name: 'BottomPopupNew',
  components: {
    DialogConfirm,
    AdvertPlaceholder,
    HeightSwitcher,
    BuyCredits,
  },
  props: {
    moveKey: { type: String, default: '' },
  },
  data() {
    return {
      mdiChevronDown,
      showBackground: false,
      showBottomPopup: false,
      showTopPopup: false,
      showAdvertConfirmation: false,
      showAdvert: false,
      blockClose: false,
      creditBalanceDisplayed: undefined,
      showCreditBuy: false,
      mdiHelpCircle,
      mdiCheckCircle,
    }
  },
  mounted() {
    /*this.$nextTick(() => {
      this.entranceAnimation = true
    })*/
    if (this.$store.getters.unlockedHints.includes(this.moveKey)) {
      const hintButton = document.getElementById('hint-button')
      const hintText = document.getElementById('hint-text')
      hintText.style.removeProperty('position')
      hintText.style.opacity = 1
      hintButton.style.display = 'none'
    }

    requestAnimationFrame(() => {
      this.showBackground = true
      this.showBottomPopup = true
      this.showTopPopup = true
    })

    this.creditBalanceDisplayed = this.creditBalance
  },
  computed: {
    moveName() {
      return this.$store.getters.actions[this.moveKey]
    },
    hint() {
      return this.$store.getters.hints[this.moveKey]
    },
    creditBalance() {
      return this.$store.getters.creditBalance
    },
    creditCost() {
      return this.$store.getters.creditCosts[this.moveKey]
    },
    showConfirmDialog() {
      return this.$store.getters.showConfirmDialog
    },
  },
  methods: {
    close(callback = undefined) {
      if (this.blockClose) {
        return
      }
      console.log('closing with callback:', callback)
      this.showBackground = false
      this.showTopPopup = false
      this.showBottomPopup = false
      setTimeout(() => {
        this.$emit('close')
        if (callback) {
          callback()
        }
      }, 500)
    },
    showHintClick() {
      this.showAdvert = true
    },
    showHintAnimation() {
      this.blockClose = true
      const hintButton = document.getElementById('hint-button')
      const hintText = document.getElementById('hint-text')
      const heightFiller = document.getElementById('height-filler')
      hintButton.ontransitionend = function hintTransitionEnd() {
        console.log('transition end')
        hintButton.removeEventListener('transitionend', hintTransitionEnd)
        heightFiller.style.height =
          hintButton.offsetHeight +
          parseFloat(window.getComputedStyle(hintButton).marginBottom) +
          'px'
        hintButton.style.display = 'none'
        requestAnimationFrame(
          function () {
            heightFiller.style.height =
              hintText.offsetHeight +
              parseFloat(window.getComputedStyle(hintText).marginBottom) +
              'px'
            heightFiller.ontransitionend = function heightTransitionEnd() {
              heightFiller.removeEventListener(
                'transitionend',
                heightTransitionEnd
              )
              heightFiller.style.removeProperty('height')
              hintText.style.removeProperty('position')
              this.$store.dispatch('unlock_hint', this.moveKey)
            }.bind(this)
            hintText.style.opacity = 1
            this.blockClose = false
          }.bind(this)
        )
      }.bind(this)
      hintButton.style.opacity = 0
    },
    advertFinished() {
      this.showAdvert = false
      this.showHintAnimation()
    },
    discoverForCredits() {
      if (this.creditBalance >= this.creditCost) {
        this.blockClose = true
        /*gsap.fromTo(
          this,
          {
            creditBalanceDisplayed: this.creditBalance,
          },
          {
            creditBalanceDisplayed: this.creditBalance - this.creditCost,
            duration: 0.5,
            onComplete: () => {
              this.blockClose = false
              this.close(() => {
                this.$store.dispatch('unlock_action', this.moveKey)
              })
            },
          }
        )*/
        this.$store.commit(
          'UPDATE_CREDIT_BALANCE',
          this.creditBalance - this.creditCost
        )
        setTimeout(() => {
          this.blockClose = false
          this.close(() => {
            //this.$store.dispatch('unlock_action', this.moveKey)
            this.$store.dispatch('reveal_action', this.moveKey)
          })
        }, 500)
      } else {
        console.log('need more credits')
        this.shakeCreditVal()
        this.showCreditBuy = true
        this.showBottomPopup = false
      }
    },
    shakeCreditVal() {
      gsap.fromTo(
        '#credit-balance',
        { x: -5 },
        {
          x: 5,
          repeat: 5,
          yoyo: true,
          ease: 'Sine.easeInOut',
          duration: 0.05,
          onComplete: function () {
            gsap.to('#credit-balance', {
              x: 0,
              ease: 'Elastic.easeOut',
              duration: 0.3,
            })
          },
        }
      )
    },
    hideBuyCredits() {
      this.showCreditBuy = false
      setTimeout(() => {
        this.showBottomPopup = true
      }, 333)
    },
  },
  watch: {
    /*creditBalanceDisplayed(new_val, old_val) {
      if (!(new_val === undefined)) {
        if (Math.round(new_val) != Math.round(old_val)) {
          this.$store.commit('UPDATE_CREDIT_BALANCE', Math.round(new_val))
        }
      }
    },*/
    creditBalance(new_val, old_val) {
      gsap.fromTo(
        this,
        {
          creditBalanceDisplayed: old_val,
        },
        {
          creditBalanceDisplayed: new_val,
          duration: 0.5,
        }
      )
    },
  },
}
</script>

<style scoped>
.bottompopup-fullscreen {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background-color: rgba(0, 0, 0, 0);
  transition: background-color 0.3s;
  z-index: 999;
}

.darken-animation {
  background-color: rgba(0, 0, 0, 0.8);
}

.popup-container {
  position: absolute;
  bottom: 0px;
  transform: translate(calc(50vw - 50%), 100%);
  width: 100%;
  max-width: 40rem;
  /*background-color: #cdf4dd;*/
  background-color: #003745;
  color: #cdf4dd;
  transition: transform 0.3s;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  font-family: 'Montserrat', sans-serif;
  padding: 0rem 1rem 0rem 1rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  /*border: 1px solid #cdf4dd;
  border-bottom: none;*/
}

.top-popdown-container {
  position: absolute;
  top: 0px;
  width: 100%;
  max-width: 40rem;
  transform: translate(calc(50vw - 50%), -100%);
  background-color: #003745;
  color: #cdf4dd;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  font-family: 'Montserrat', sans-serif;
  padding: 1rem 1rem 0rem 1rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.3s;
}

#height-filler {
  transition: height 0.5s;
}

.popup-container-appear {
  transform: translate(calc(50vw - 50%), 0%);
}

.popdown-container-appear {
  transform: translate(calc(50vw - 50%), 0%);
}

.done-button {
  width: 75%;
  display: inline-block;
  padding: 1em;
  text-align: center;
  border: 1px solid #cdf4dd;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.5s ease, color 0.5s ease;
  margin-bottom: 1rem;
}

@media (hover: hover) {
  .done-button:hover {
    background-color: rgba(204, 244, 221, 0.1);
  }
}

.hint-button-container {
  width: 75%;
  padding: 1em;
  text-align: center;
  border: 1px solid #cdf4dd;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.5s ease, color 0.5s ease, opacity 0.5s ease;
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.hint-text {
  width: 100%;
  text-align: center;
  font-family: 'Montserrat', sans-serif;
  transition: opacity 0.5s;
  margin-bottom: 2rem;
  opacity: 0;
  font-style: italic;
}

.unlock-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  /*border-top: 1px dotted #cdf4dd;*/
  padding-top: 1.5rem;
  width: 100%;
}

.credit-header {
  font-size: 1.25rem;
  font-weight: 300;
}

/*.credit-count {
  border-radius: 50%;
  color: #003745;
  background-color: #cdf4dd;
  font-size: 2rem;
  width: 2.5rem;
  height: 2.5rem;
  text-align: center;
}*/

.credit-count {
  color: #ff3633;
  font-size: 2.5rem;
  font-weight: 600;
  /*margin-bottom: 1rem;*/
}

.dialog-appear-enter-active,
.dialog-appear-leave-active {
  transition: all 0.3s;
}

.dialog-appear-enter,
.dialog-appear-leave-to {
  opacity: 0;
  /*transform: translate(calc(50vw - 50%), calc(50vh - 50% - 15px));*/
}
</style>
